import { render, staticRenderFns } from "./draggableTable.vue?vue&type=template&id=2a6e8778&scoped=true&"
import script from "./draggableTable.vue?vue&type=script&lang=js&"
export * from "./draggableTable.vue?vue&type=script&lang=js&"
import style0 from "./draggableTable.vue?vue&type=style&index=0&id=2a6e8778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e8778",
  null
  
)

export default component.exports